import { foldersActions } from "./actions";
import { IFolderData, IFoldersDataServer, IFoldersState } from "./interface";

export const folderDataInitialState: IFolderData = {
  folderIds: [],
};

export const initialState: IFoldersState = {
  foldersMap: {},
  loaders: {
    fetchFolder: false,
    createFolder: false,
    updateFolder: false,
    deleteFolder: false,
    fetchFolderById: false,
    bulkUpdateFormFolderPath: false,
  },
  errors: {
    fetchFolder: "",
    createFolder: "",
    updateFolder: "",
    deleteFolder: "",
    fetchFolderById: "",
    bulkUpdateFormFolderPath: "",
  },
  folderData: folderDataInitialState,
};

export const foldersReducer = (
  state: IFoldersState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case foldersActions.FETCH_FOLDERS_BY_PATH: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFolder: true,
        },
      };
    }
    case foldersActions.FETCH_FOLDERS_BY_PATH_SUCCESS: {
      const folders = action.payload
      // const folderIds = [...(state?.folderData?.folderIds || [])] // un comment this line if pagination is used
      const folderIds = []
      const updatedFoldersMap = { ...(state.foldersMap || {}) }

      folders.forEach((folderData: IFoldersDataServer) => {
        const folderId = folderData?.id;
        if (!folderIds.includes(folderId)) {
          folderIds.push(folderId);
        }
        updatedFoldersMap[folderId] = folderData;
      });
      return {
        ...state,
        foldersMap: updatedFoldersMap,
        folderData: {
          ...state.folderData,
          folderIds: folderIds
        },
        loaders: {
          ...state.loaders,
          fetchFolder: false,
        },
      };
    }
    case foldersActions.FETCH_FOLDERS_BY_PATH_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFolder: false,
        },
        errors: {
          ...state.errors,
          fetchFolder: error,
        },
      };
    }

    case foldersActions.CREATE_FOLDER: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          createFolder: true,
        },
      };
    }
    case foldersActions.CREATE_FOLDER_SUCCESS: {
      const folderData: IFoldersDataServer = action.payload
      const folderIds = [...(state?.folderData?.folderIds || [])]
      const updatedFoldersMap = { ...(state.foldersMap || {}) }
      const folderId = folderData?.id;
      if (!folderIds.includes(folderId)) {
        folderIds.push(folderId);
      }
      updatedFoldersMap[folderId] = folderData;
      return {
        ...state,
        foldersMap: updatedFoldersMap,
        folderData: {
          ...state.folderData,
          folderIds: folderIds
        },
        loaders: {
          ...state.loaders,
          createFolder: false,
        },
      };
    }
    case foldersActions.CREATE_FOLDER_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          createFolder: false,
        },
        errors: {
          ...state.errors,
          createFolder: error,
        },
      };
    }

    case foldersActions.UPDATE_FOLDER: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateFolder: true,
        },
      };
    }
    case foldersActions.UPDATE_FOLDER_SUCCESS: {
      const folderData: IFoldersDataServer = action.payload
      const folderIds = [...(state?.folderData?.folderIds || [])]
      const updatedFoldersMap = { ...(state.foldersMap || {}) }
      const folderId = folderData?.id;
      if (!folderIds.includes(folderId)) {
        folderIds.push(folderId);
      }
      updatedFoldersMap[folderId] = folderData;
      return {
        ...state,
        foldersMap: updatedFoldersMap,
        folderData: {
          ...state.folderData,
          folderIds: folderIds
        },
        loaders: {
          ...state.loaders,
          updateFolder: false,
        },
      };
    }
    case foldersActions.UPDATE_FOLDER_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          updateFolder: false,
        },
        errors: {
          ...state.errors,
          updateFolder: error,
        },
      };
    }

    case foldersActions.DELETE_FOLDER: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteFolder: true,
        },
      };
    }
    case foldersActions.DELETE_FOLDER_SUCCESS: {
      const folderId: string = action.payload
      const updatedFoldersMap = { ...(state.foldersMap || {}) }
      const folderIds = [...(state?.folderData?.folderIds || [])]
      const updatedFolderIds = folderIds.filter(item => item !== folderId);
      delete updatedFoldersMap[folderId];
      return {
        ...state,
        foldersMap: updatedFoldersMap,
        folderData: {
          ...state.folderData,
          folderIds: updatedFolderIds
        },
        loaders: {
          ...state.loaders,
          deleteFolder: false,
        },
      };
    }
    case foldersActions.DELETE_FOLDER_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          deleteFolder: false,
        },
        errors: {
          ...state.errors,
          deleteFolder: error,
        },
      };
    }

    case foldersActions.FETCH_FOLDER_BY_ID: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFolderById: true,
        },
      };
    }
    case foldersActions.FETCH_FOLDER_BY_ID_SUCCESS: {
      const folderData: IFoldersDataServer = action.payload
      const folderIds = [...(state?.folderData?.folderIds || [])]
      const updatedFoldersMap = { ...(state.foldersMap || {}) }
      const folderId = folderData?.id;
      if (!folderIds.includes(folderId)) {
        folderIds.push(folderId);
      }
      updatedFoldersMap[folderId] = folderData;
      return {
        ...state,
        foldersMap: updatedFoldersMap,
        folderData: {
          ...state.folderData,
          folderIds: folderIds
        },
        loaders: {
          ...state.loaders,
          fetchFolderById: false,
        },
      };
    }
    case foldersActions.FETCH_FOLDER_BY_ID_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          fetchFolderById: false,
        },
        errors: {
          ...state.errors,
          fetchFolderById: error,
        },
      };
    }


    case foldersActions.BULK_UPDATE_FORM_FOLDER_PATH: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          bulkUpdateFormFolderPath: true,
        },
      };
    }
    case foldersActions.BULK_UPDATE_FORM_FOLDER_PATH_SUCCESS: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          bulkUpdateFormFolderPath: false,
        },
      };
    }
    case foldersActions.BULK_UPDATE_FORM_FOLDER_PATH_FAILURE: {
      const error = action.payload.error;
      return {
        ...state,
        loaders: {
          ...state.loaders,
          bulkUpdateFormFolderPath: false,
        },
        errors: {
          ...state.errors,
          bulkUpdateFormFolderPath: error,
        },
      };
    }





    default:
      return state;
  }
};
